// PermissionState — "not permitted" (§7 States, README "Permission").
//
// Translated from prototype/screens-states.jsx `Empty` (lock icon variant).
// README: "a plain explanation and a way back, not a bare 'You do not have
// access' heading." This component never checks usePermissions() itself —
// the caller resolves usePermissions().isLoading AND its own data load
// before deciding to render this at all (fail-closed, per CLAUDE.md/README).
import React from 'react';
import { Box, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

interface PermissionStateProps {
  /** e.g. "You don't have access to Helpdesk admin". Still specific, not bare. */
  title: string;
  /** Plain explanation, e.g. what permission is missing and what's unaffected. */
  body: string;
  /** "Back to workspace" or similar — the way back. Required; this state exists to offer one. */
  action: React.ReactNode;
}

export default function PermissionState({ title, body, action }: PermissionStateProps) {
  return (
    <Box
      sx={{
        padding: '40px 28px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '12px',
        textAlign: 'center'
      }}
    >
      <Box
        sx={{
          width: 44,
          height: 44,
          borderRadius: 'var(--r-md)',
          display: 'grid',
          placeItems: 'center',
          backgroundColor: 'var(--card-sub)',
          color: 'var(--muted)',
          border: '1px solid var(--hairline)'
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: 21 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: 14.5, fontWeight: 600, color: 'var(--ink)' }}>{title}</Typography>
        <Typography sx={{ fontSize: 12.5, color: 'var(--muted)', marginTop: '5px', lineHeight: 1.6, maxWidth: 340 }}>
          {body}
        </Typography>
      </Box>
      <Box sx={{ display: 'flex', gap: '8px', marginTop: '2px' }}>{action}</Box>
    </Box>
  );
}
